if (!customElements.get('dityy-sales-controls')) {
  customElements.define('dityy-sales-controls', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.bar = this.querySelector('.ds-sticky');
      if (!this.main || !this.bar) return;
      // Keep the fixed bar outside the theme's transformed product columns.
      document.body.append(this.bar);
      const button = this.main.querySelector('product-form [type="submit"]');
      const translate = () => {
        const span = button?.querySelector('span');
        const translations = {'Add to cart': 'أضف للسلة', 'Sold out': 'غير متاح حاليا', 'Unavailable': 'الاختيار غير متاح'};
        const translated = translations[span?.textContent.trim()];
        if (translated) span.textContent = translated;
      };
      translate();
      this.observer = new MutationObserver(translate);
      if (button) this.observer.observe(button, {childList: true, subtree: true, characterData: true});
      const label = this.main.querySelector('.quantity__label');
      if (label) {
        const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.replace('Quantity', 'الكمية');
      }
      if (new URL(location.href).searchParams.get('view') === 'direct-sale' && typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId !== this.dataset.section) return;
          const url = new URL(location.href);
          url.searchParams.set('view', 'direct-sale');
          history.replaceState({}, '', url);
        });
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.bar?.remove();
    }
  });
}
